(function () {
  const BODY_CLASS = 'sticky-atc-pdp-visible';
  const CHECK_SVG =
    '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function initStickyAtc() {
    const sticky = document.querySelector('.sticky-atc-pdp');
    if (!sticky || sticky.dataset.initialized === 'true') return;

    const productPage =
      sticky.closest('product-page') || document.querySelector('product-page');
    if (!productPage) return;

    const mainAtcAnchor =
      productPage.querySelector('.product__cart-actions-holder') ||
      productPage.querySelector('.product__cart-actions') ||
      productPage.querySelector('product-form');
    const mainAtcButton =
      productPage.querySelector('.product__cart-actions .product__add-to-cart') ||
      productPage.querySelector('.product__add-to-cart') ||
      productPage.querySelector('.add-to-cart-btn');
    const mainAtc = mainAtcAnchor || mainAtcButton;
    if (!mainAtc) return;

    sticky.dataset.initialized = 'true';

    const sectionId = sticky.dataset.sectionId;
    const variantsMount = sticky.querySelector('[data-sticky-variants]');
    const stickyBtn = sticky.querySelector('[data-sticky-atc-trigger]');
    const stickyBtnText = stickyBtn?.querySelector('.add-to-cart__text');

    const productVariants = productPage.querySelector(
      `product-variants[data-id="${sectionId}"]`
    );

    let syncing = false;
    let openDropdown = null;
    let isStickyShown = false;
    let visibilityRaf = 0;

    function isVisibleRoot(el) {
      if (!el) return false;
      if (variantsMount && variantsMount.contains(el)) return false;
      const style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    }

    function getMainVariantsRoot() {
      /* Prefer the visible Product-variant swatches UI shoppers actually use.
         The disabled/hidden product-variants picker can still exist in DOM and
         stay stuck on the first shade, which made sticky ATC look wrong. */
      const swatchRoots = productPage.querySelectorAll(
        '.variant-swatches-container .product__variants'
      );
      for (const root of swatchRoots) {
        if (isVisibleRoot(root)) return root;
      }

      const pickerRoots = productPage.querySelectorAll(
        'product-variants .product__variants'
      );
      for (const root of pickerRoots) {
        if (isVisibleRoot(root)) return root;
      }

      const allRoots = productPage.querySelectorAll('.product__variants');
      for (const root of allRoots) {
        if (isVisibleRoot(root)) return root;
      }

      return (
        productPage.querySelector('.variant-swatches-container .product__variants') ||
        productPage.querySelector('product-variants .product__variants') ||
        productPage.querySelector('.product__variants')
      );
    }

    function getStickyVariantsRoot() {
      return variantsMount?.querySelector('.product__variants') || null;
    }

    function getMainInputById(inputId) {
      if (!inputId) return null;
      const root = getMainVariantsRoot();
      if (!root) return null;

      if (typeof CSS !== 'undefined' && CSS.escape) {
        return root.querySelector('#' + CSS.escape(inputId));
      }

      return Array.from(
        root.querySelectorAll('.product-variant__input, .product-variant-value')
      ).find((input) => input.id === inputId);
    }

    function getOptionLabel(mainGroup) {
      const nameEl = mainGroup.querySelector('.product-variant__name');
      if (!nameEl) return 'Shade';

      /* Liquid leaves newlines inside .product-variant__name ("Select\nColor :- …"),
         so normalize whitespace and drop the live shade <span> before parsing.
         Otherwise the sticky label freezes as "SELECT COLOR :- 500 CEO" while
         only the secondary trigger name updates. */
      const clone = nameEl.cloneNode(true);
      clone.querySelectorAll('span, div').forEach((el) => el.remove());
      const text = clone.textContent
        .replace(/\s+/g, ' ')
        .replace(/:-/g, ' ')
        .trim()
        .replace(/^select\s+/i, '')
        .trim();

      return text || 'Shade';
    }

    function getSelectedMainItem(mainGroup, groupIndex) {
      /* selected-var is updated on every shade click (including cart.js) and is
         the most reliable signal on Product-variant PDPs. */
      const selectedLabel = mainGroup.querySelector(
        '.product-variant__label.selected-var'
      );
      if (selectedLabel) return selectedLabel.closest('.product-variant__item');

      const checked = mainGroup.querySelector(
        '.product-variant__input:checked, .product-variant-value:checked'
      );
      if (checked) return checked.closest('.product-variant__item');

      const variantOption = productVariants?.currentVariant?.options?.[groupIndex];
      if (variantOption) {
        for (const item of mainGroup.querySelectorAll('.product-variant__item')) {
          const input = item.querySelector(
            '.product-variant__input, .product-variant-value'
          );
          if (input?.value === variantOption) return item;
        }
      }

      const shadeSpan = mainGroup.querySelector(
        '.concealer-selected-shade > span'
      );
      const shadeValue = shadeSpan?.textContent?.trim();
      if (shadeValue) {
        for (const item of mainGroup.querySelectorAll('.product-variant__item')) {
          const input = item.querySelector(
            '.product-variant__input, .product-variant-value'
          );
          if (input?.value === shadeValue) return item;
        }
      }

      return mainGroup.querySelector('.product-variant__item');
    }

    function updateShadeLabelInGroup(group, value) {
      if (!group || value == null) return;
      group.querySelectorAll('.concealer-selected-shade > span').forEach((el) => {
        el.textContent = value;
      });
    }

    function updateDropdownFromOption(dropdown, optionEl) {
      if (!dropdown || !optionEl) return;
      const triggerSwatch = dropdown.querySelector(
        '.sticky-atc-pdp__shade-trigger-swatch'
      );
      const triggerName = dropdown.querySelector(
        '.sticky-atc-pdp__shade-trigger-name'
      );
      const optionName = optionEl.querySelector(
        '.sticky-atc-pdp__shade-option-name'
      );

      if (triggerName) {
        triggerName.textContent =
          optionName?.textContent?.trim() ||
          optionEl.dataset.optionValue ||
          '';
      }

      if (triggerSwatch) {
        const optionSwatches = optionEl.querySelectorAll(
          '.sticky-atc-pdp__shade-swatch'
        );
        if (optionSwatches.length > 1) {
          triggerSwatch.hidden = false;
          triggerSwatch.classList.remove('sticky-atc-pdp__shade-swatch--empty');
          triggerSwatch.removeAttribute('style');
          triggerSwatch.classList.add(
            'sticky-atc-pdp__shade-trigger-swatch--pair'
          );
          triggerSwatch.innerHTML = '';
          optionSwatches.forEach((source) => {
            const chip = document.createElement('span');
            chip.className = 'sticky-atc-pdp__shade-swatch';
            chip.setAttribute('aria-hidden', 'true');
            const inlineStyle = source.getAttribute('style');
            if (inlineStyle) chip.setAttribute('style', inlineStyle);
            triggerSwatch.appendChild(chip);
          });
        } else {
          const source = optionSwatches[0];
          triggerSwatch.classList.remove(
            'sticky-atc-pdp__shade-trigger-swatch--pair'
          );
          triggerSwatch.innerHTML = '';
          if (!source) {
            triggerSwatch.hidden = true;
            triggerSwatch.classList.add('sticky-atc-pdp__shade-swatch--empty');
            triggerSwatch.removeAttribute('style');
          } else {
            triggerSwatch.hidden = false;
            triggerSwatch.classList.remove(
              'sticky-atc-pdp__shade-swatch--empty'
            );
            const inlineStyle = source.getAttribute('style');
            if (inlineStyle) {
              triggerSwatch.setAttribute('style', inlineStyle);
            } else {
              triggerSwatch.removeAttribute('style');
              triggerSwatch.style.backgroundImage = source.style.backgroundImage;
              triggerSwatch.style.backgroundColor = source.style.backgroundColor;
            }
          }
        }
      }

      dropdown.querySelectorAll('.sticky-atc-pdp__shade-option').forEach((opt) => {
        const isSelected = opt === optionEl;
        opt.classList.toggle('is-selected', isSelected);
        opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    }

    function updateShadeLabelsFromVariant(variant) {
      if (!variant) return;
      const values = variant.options || [];
      const roots = [getMainVariantsRoot(), getStickyVariantsRoot()].filter(Boolean);
      roots.forEach((root) => {
        root.querySelectorAll('.product-variant').forEach((group, index) => {
          if (values[index] != null) {
            updateShadeLabelInGroup(group, values[index]);
          }
        });
      });
    }

    function getSwatchSource(label) {
      if (!label) return null;
      return (
        label.querySelector('.tb-shade-swatch') ||
        label.querySelector('.tb-combo-swatch-pair > span') ||
        label.querySelector('span[aria-hidden="true"]:not(.tb-combo-swatch-pair)') ||
        label.querySelector('span')
      );
    }

    function applyAllSwatchesFromLabel(label, targetEl) {
      if (!label || !targetEl) return;
      const pair = label.querySelector('.tb-combo-swatch-pair');
      const swatches = pair
        ? pair.querySelectorAll('.tb-shade-swatch, span')
        : [];

      if (swatches.length > 1) {
        targetEl.hidden = false;
        targetEl.classList.remove('sticky-atc-pdp__shade-swatch--empty');
        targetEl.removeAttribute('style');
        targetEl.classList.add('sticky-atc-pdp__shade-trigger-swatch--pair');
        targetEl.innerHTML = '';
        swatches.forEach((source) => {
          const chip = document.createElement('span');
          chip.className = 'sticky-atc-pdp__shade-swatch';
          chip.setAttribute('aria-hidden', 'true');
          const inlineStyle = source.getAttribute('style');
          if (inlineStyle) chip.setAttribute('style', inlineStyle);
          targetEl.appendChild(chip);
        });
        return;
      }

      targetEl.classList.remove('sticky-atc-pdp__shade-trigger-swatch--pair');
      targetEl.innerHTML = '';
      applySwatchFromLabel(label, targetEl);
    }

    function applySwatchFromLabel(label, targetEl) {
      const source = getSwatchSource(label);
      if (!source) {
        targetEl.hidden = true;
        targetEl.classList.add('sticky-atc-pdp__shade-swatch--empty');
        targetEl.removeAttribute('style');
        return;
      }

      targetEl.hidden = false;
      targetEl.classList.remove('sticky-atc-pdp__shade-swatch--empty');
      const inlineStyle = source.getAttribute('style');
      if (inlineStyle) {
        targetEl.setAttribute('style', inlineStyle);
      } else {
        targetEl.style.backgroundImage = source.style.backgroundImage;
        targetEl.style.backgroundColor = source.style.backgroundColor;
      }
    }

    function createSwatchEl(label) {
      const el = document.createElement('span');
      el.className = 'sticky-atc-pdp__shade-swatch';
      el.setAttribute('aria-hidden', 'true');
      applyAllSwatchesFromLabel(label, el);
      return el;
    }

    function closeAllDropdowns() {
      variantsMount
        ?.querySelectorAll('.sticky-atc-pdp__shade-dropdown.is-open')
        .forEach((dropdown) => {
          dropdown.classList.remove('is-open');
          const trigger = dropdown.querySelector('.sticky-atc-pdp__shade-trigger');
          const menu = dropdown.querySelector('.sticky-atc-pdp__shade-menu');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (menu) menu.hidden = true;
        });
      openDropdown = null;
    }

    function toggleDropdown(dropdown) {
      const isOpen = dropdown.classList.contains('is-open');
      closeAllDropdowns();
      if (isOpen) return;

      const trigger = dropdown.querySelector('.sticky-atc-pdp__shade-trigger');
      const menu = dropdown.querySelector('.sticky-atc-pdp__shade-menu');
      dropdown.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (menu) menu.hidden = false;
      openDropdown = dropdown;
    }

    function getSelectedShadeName(mainGroup, selectedItem, input) {
      const fromInput = input?.value?.trim();
      if (fromInput) return fromInput;

      const fromLabel = mainGroup
        ?.querySelector('.concealer-selected-shade > span, .product-variant__name > span')
        ?.textContent?.trim();
      if (fromLabel) return fromLabel;

      const checked = selectedItem?.querySelector(
        '.product-variant__input:checked, .product-variant-value:checked'
      );
      return checked?.value?.trim() || '';
    }

    function updateDropdownFromGroup(dropdown, mainGroup, groupIndex) {
      if (!dropdown || !mainGroup) return;

      const selectedItem = getSelectedMainItem(mainGroup, groupIndex);
      if (!selectedItem) return;

      const label = selectedItem.querySelector('.product-variant__label');
      const input = selectedItem.querySelector(
        '.product-variant__input, .product-variant-value'
      );
      const triggerSwatch = dropdown.querySelector(
        '.sticky-atc-pdp__shade-trigger-swatch'
      );
      const triggerName = dropdown.querySelector('.sticky-atc-pdp__shade-trigger-name');
      const shadeName = getSelectedShadeName(mainGroup, selectedItem, input);

      if (triggerSwatch) applyAllSwatchesFromLabel(label, triggerSwatch);
      if (triggerName && shadeName) triggerName.textContent = shadeName;

      dropdown.querySelectorAll('.sticky-atc-pdp__shade-option').forEach((opt) => {
        const isSelected =
          (input?.id && opt.dataset.mainInputId === input.id) ||
          (shadeName && opt.dataset.optionValue === shadeName) ||
          (input?.value && opt.dataset.optionValue === input.value);
        opt.classList.toggle('is-selected', isSelected);
        opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    }

    function buildShadeDropdown(stickyGroup, mainGroup, groupIndex) {
      const container = stickyGroup.querySelector('.product-variant__container');
      if (!container) return null;

      /* Remove cloned PDP shade title entirely — sticky trigger owns the label. */
      stickyGroup.querySelector('.product-variant__name')?.remove();

      const mainItems = mainGroup.querySelectorAll('.product-variant__item');
      if (!mainItems.length) return null;

      const optionLabel = getOptionLabel(mainGroup);
      const dropdown = document.createElement('div');
      dropdown.className = 'sticky-atc-pdp__shade-dropdown';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'sticky-atc-pdp__shade-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');

      const triggerSwatch = document.createElement('span');
      triggerSwatch.className = 'sticky-atc-pdp__shade-trigger-swatch';
      triggerSwatch.setAttribute('aria-hidden', 'true');

      const triggerText = document.createElement('span');
      triggerText.className = 'sticky-atc-pdp__shade-trigger-text';

      const triggerLabel = document.createElement('span');
      triggerLabel.className = 'sticky-atc-pdp__shade-trigger-label';
      triggerLabel.textContent = optionLabel;

      const triggerName = document.createElement('span');
      triggerName.className = 'sticky-atc-pdp__shade-trigger-name';

      triggerText.append(triggerLabel, triggerName);

      const chevron = document.createElement('span');
      chevron.className = 'sticky-atc-pdp__shade-chevron';
      chevron.setAttribute('aria-hidden', 'true');
      chevron.innerHTML =
        '<svg width="10" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

      trigger.append(triggerSwatch, triggerText, chevron);

      const menu = document.createElement('ul');
      menu.className = 'sticky-atc-pdp__shade-menu';
      menu.setAttribute('role', 'listbox');
      menu.hidden = true;

      mainItems.forEach((mainItem) => {
        const mainInput = mainItem.querySelector(
          '.product-variant__input, .product-variant-value'
        );
        const label = mainItem.querySelector('.product-variant__label');
        if (!mainInput || !label) return;

        const option = document.createElement('li');
        option.className = 'sticky-atc-pdp__shade-option';
        option.setAttribute('role', 'option');
        option.dataset.mainInputId = mainInput.id;
        option.dataset.optionValue = mainInput.value;
        option.setAttribute('aria-selected', 'false');

        const optionSwatch = createSwatchEl(label);
        const optionName = document.createElement('span');
        optionName.className = 'sticky-atc-pdp__shade-option-name';
        optionName.textContent = mainInput.value;

        const optionCheck = document.createElement('span');
        optionCheck.className = 'sticky-atc-pdp__shade-option-check';
        optionCheck.innerHTML = CHECK_SVG;

        option.append(optionSwatch, optionName, optionCheck);
        menu.appendChild(option);
      });

      dropdown.append(trigger, menu);
      container.hidden = true;
      container.setAttribute('aria-hidden', 'true');
      stickyGroup.appendChild(dropdown);

      updateDropdownFromGroup(dropdown, mainGroup, groupIndex);
      return dropdown;
    }

    function buildStickyVariants() {
      const mainRoot = getMainVariantsRoot();
      if (!mainRoot || !variantsMount) return;

      closeAllDropdowns();

      /* Cloning via innerHTML inserts radios with the same name+checked as the
         live PDP. The browser then unchecks the originals, so the selected
         swatch loses its border until the shopper clicks again. */
      const previouslyChecked = Array.from(
        mainRoot.querySelectorAll(
          '.product-variant__input:checked, .product-variant-value:checked'
        )
      );

      variantsMount.innerHTML = mainRoot.outerHTML;
      const stickyRoot = getStickyVariantsRoot();
      if (!stickyRoot) return;

      stickyRoot.querySelectorAll('input').forEach((input) => {
        input.removeAttribute('name');
        input.removeAttribute('id');
        input.removeAttribute('checked');
        input.checked = false;
        input.setAttribute('tabindex', '-1');
        input.setAttribute('aria-hidden', 'true');
      });

      previouslyChecked.forEach((input) => {
        input.checked = true;
      });

      if (!previouslyChecked.length) {
        mainRoot
          .querySelectorAll('.product-variant__input, .product-variant-value')
          .forEach((input) => {
            const label = input
              .closest('.product-variant__item')
              ?.querySelector('.product-variant__label');
            if (input.defaultChecked || label?.classList.contains('selected-var')) {
              input.checked = true;
            }
          });
      }

      stickyRoot.querySelectorAll('label').forEach((label) => {
        label.removeAttribute('for');
        label.setAttribute('aria-hidden', 'true');
        label.hidden = true;
      });

      /* Shade category tabs belong on the main PDP only — never in sticky ATC. */
      stickyRoot.querySelectorAll('[data-tb-shade-tabs], .tb-shade-tabs').forEach((el) => {
        el.remove();
      });

      const mainGroups = mainRoot.querySelectorAll('.product-variant');
      const stickyGroups = stickyRoot.querySelectorAll('.product-variant');

      stickyGroups.forEach((stickyGroup, index) => {
        buildShadeDropdown(stickyGroup, mainGroups[index], index);
      });
    }

    function syncStickyDropdowns() {
      const mainRoot = getMainVariantsRoot();
      if (!mainRoot) return;

      const mainGroups = mainRoot.querySelectorAll('.product-variant');
      variantsMount
        ?.querySelectorAll('.sticky-atc-pdp__shade-dropdown')
        .forEach((dropdown, index) => {
          updateDropdownFromGroup(dropdown, mainGroups[index], index);
        });
    }

    function syncStickyFromMain() {
      if (syncing) return;
      syncing = true;
      syncStickyDropdowns();
      syncing = false;
    }

    function applyMainVariantSelection(mainInput) {
      const value = mainInput.value;
      const mainItem = mainInput.closest('.product-variant__item');
      const mainGroup = mainInput.closest('.product-variant');

      mainGroup?.querySelectorAll('.product-variant__label').forEach((label) => {
        label.classList.remove('selected-var');
      });
      mainItem?.querySelector('.product-variant__label')?.classList.add('selected-var');

      mainInput.checked = true;
      mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      mainInput.dispatchEvent(new Event('input', { bubbles: true }));

      updateShadeLabelInGroup(mainGroup, value);
      syncStickyFromMain();
      requestAnimationFrame(syncStickyFromMain);
    }

    function selectMainVariantFromOption(optionEl) {
      const mainInput =
        getMainInputById(optionEl.dataset.mainInputId) ||
        (() => {
          const root = getMainVariantsRoot();
          if (!root || !optionEl.dataset.optionValue) return null;
          return Array.from(
            root.querySelectorAll('.product-variant__input, .product-variant-value')
          ).find((input) => input.value === optionEl.dataset.optionValue);
        })();
      if (!mainInput) return;

      const dropdown = optionEl.closest('.sticky-atc-pdp__shade-dropdown');
      /* Update sticky trigger immediately so it never lags on the first shade. */
      updateDropdownFromOption(dropdown, optionEl);
      applyMainVariantSelection(mainInput);
      closeAllDropdowns();
    }

    function syncAtcButtonFromMain() {
      if (!stickyBtn) return;
      const sourceBtn = mainAtcButton || mainAtc;
      stickyBtn.classList.toggle('disabled', sourceBtn.classList.contains('disabled'));
      stickyBtn.disabled = sourceBtn.classList.contains('disabled');
      const sourceText = sourceBtn.querySelector?.('.add-to-cart__text');
      if (stickyBtnText && sourceText) {
        stickyBtnText.textContent = sourceText.textContent;
      }
    }

    function updateBodyPadding() {
      if (!isStickyShown) {
        document.documentElement.style.removeProperty('--sticky-atc-pdp-height');
        return;
      }

      const height = Math.ceil(sticky.offsetHeight);
      if (height > 0) {
        document.documentElement.style.setProperty(
          '--sticky-atc-pdp-height',
          `${height}px`
        );
      }
    }

    function setVisible(visible) {
      if (visible === isStickyShown) return;
      isStickyShown = visible;

      if (!visible) closeAllDropdowns();

      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle(BODY_CLASS, visible);

      if (visible) {
        syncStickyFromMain();
        updateBodyPadding();
        requestAnimationFrame(() => requestAnimationFrame(updateBodyPadding));
      } else {
        document.documentElement.style.removeProperty('--sticky-atc-pdp-height');
      }
    }

    if (typeof ResizeObserver !== 'undefined') {
      const bodyPaddingObserver = new ResizeObserver(() => {
        if (isStickyShown) updateBodyPadding();
      });
      bodyPaddingObserver.observe(sticky);
    }

    window.addEventListener('resize', () => {
      if (isStickyShown) updateBodyPadding();
    });

    buildStickyVariants();
    syncStickyFromMain();
    syncAtcButtonFromMain();

    [100, 400, 1000].forEach((delay) => {
      setTimeout(syncStickyFromMain, delay);
    });

    variantsMount?.addEventListener('click', (e) => {
      const option = e.target.closest('.sticky-atc-pdp__shade-option');
      if (option && variantsMount.contains(option)) {
        e.preventDefault();
        e.stopPropagation();
        selectMainVariantFromOption(option);
        return;
      }

      const trigger = e.target.closest('.sticky-atc-pdp__shade-trigger');
      if (trigger && variantsMount.contains(trigger)) {
        e.preventDefault();
        e.stopPropagation();
        toggleDropdown(trigger.closest('.sticky-atc-pdp__shade-dropdown'));
      }
    });

    variantsMount?.addEventListener('keydown', (e) => {
      const option = e.target.closest('.sticky-atc-pdp__shade-option');
      if (option && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        selectMainVariantFromOption(option);
        return;
      }

      const trigger = e.target.closest('.sticky-atc-pdp__shade-trigger');
      if (trigger && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        toggleDropdown(trigger.closest('.sticky-atc-pdp__shade-dropdown'));
      }

      if (e.key === 'Escape') closeAllDropdowns();
    });

    document.addEventListener('click', (e) => {
      if (!variantsMount?.contains(e.target)) closeAllDropdowns();
    });

    productPage.addEventListener('change', (e) => {
      if (
        !e.target.matches(
          '.product-variant__input, .product-variant-value, input[type="radio"]'
        )
      ) {
        return;
      }
      if (variantsMount?.contains(e.target)) return;
      if (!e.target.closest('.product-variant, .variant-swatches-container')) {
        return;
      }

      const group = e.target.closest('.product-variant');
      const label = e.target
        .closest('.product-variant__item')
        ?.querySelector('.product-variant__label');
      if (group && label) {
        group.querySelectorAll('.product-variant__label').forEach((el) => {
          el.classList.remove('selected-var');
        });
        label.classList.add('selected-var');
      }
      updateShadeLabelInGroup(group, e.target.value);
      syncStickyFromMain();
      requestAnimationFrame(syncStickyFromMain);
    });

    productPage.addEventListener('click', (e) => {
      if (variantsMount?.contains(e.target)) return;
      const label = e.target.closest('.product-variant__label');
      if (!label) return;

      const input =
        label
          .closest('.product-variant__item')
          ?.querySelector('.product-variant__input, .product-variant-value') ||
        (label.htmlFor && document.getElementById(label.htmlFor));

      /*
        Setting input.checked during the label click (before the browser default)
        suppresses the native change event. ProductVariants / Product-variant ATC
        then never learn about the new shade, so the URL stays put and ATC keeps
        adding the default variant. Force the same path sticky dropdowns use.
      */
      if (input && !input.checked) {
        e.preventDefault();
        applyMainVariantSelection(input);
        return;
      }

      const group = label.closest('.product-variant');
      if (group && label) {
        group.querySelectorAll('.product-variant__label').forEach((el) => {
          el.classList.remove('selected-var');
        });
        label.classList.add('selected-var');
      }
      if (input) updateShadeLabelInGroup(group, input.value);

      syncStickyFromMain();
      requestAnimationFrame(syncStickyFromMain);
    });

    if (productVariants) {
      productVariants.addEventListener('VARIANT_CHANGE', (e) => {
        if (e.target?.currentVariant) {
          updateShadeLabelsFromVariant(e.target.currentVariant);
        }
        syncStickyFromMain();
        syncAtcButtonFromMain();
      });
    }

    const mainAtcObserver = new MutationObserver(syncAtcButtonFromMain);
    mainAtcObserver.observe(mainAtcButton || mainAtc, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
      subtree: true,
      childList: true,
    });

    function evaluateStickyVisibility() {
      if (visibilityRaf) return;
      visibilityRaf = requestAnimationFrame(() => {
        visibilityRaf = 0;

        const rect = mainAtc.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        /* Show sticky whenever the main ATC is off-screen — both above
           (page top / gallery) and below (scrolled past ATC). */
        const edgePad = 48;
        const inView =
          rect.bottom > edgePad && rect.top < vh - edgePad;

        setVisible(!inView);
      });
    }

    evaluateStickyVisibility();
    window.addEventListener('scroll', evaluateStickyVisibility, { passive: true });
    window.addEventListener('resize', evaluateStickyVisibility, { passive: true });

    stickyBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      const sourceBtn = mainAtcButton || mainAtc;
      if (sourceBtn.disabled || sourceBtn.classList.contains('disabled')) return;
      sourceBtn.click();
    });

    if (productVariants?.currentVariant) {
      updateShadeLabelsFromVariant(productVariants.currentVariant);
      syncStickyFromMain();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }

  document.addEventListener('shopify:section:load', initStickyAtc);
})();
